/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Media_UploadedInputs */

const vi_media_uploaded = /** @type {(inputs: Media_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã tải lên ${i?.count} file.`)
};

/**

* @param {Media_UploadedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_uploaded = /** @type {((inputs: Media_UploadedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_UploadedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_uploaded(inputs)
});